import { MEMBER_TYPE, } from "@erp/shared/components/ui/Dialog/MemberSearchDialog/member.types";
import { formatDate, formatHour } from "@erp/shared/utils/date/formatted-date";
import { requiredInputRule } from "@erp/shared/utils/form/rules";
export const purchaseInboundMemberInfo = [
    {
        type: MEMBER_TYPE.확인,
        givenName: "",
        id: null,
        email: "",
        checked_date: "",
        userName: "",
    },
    {
        type: MEMBER_TYPE.승인,
        givenName: "",
        id: null,
        email: "",
        checked_date: "",
        userName: "",
    },
    {
        type: MEMBER_TYPE.자재담당자,
        givenName: "",
        id: null,
        email: "",
        checked_date: "",
        userName: "",
    },
];
/**
 * @description 구매 입고 신청 시 입력 필드
 */
export const purchaseInboundCardInfoInputs = [
    {
        label: "입고일자",
        key: "inboundDate",
        column_name: "inboundDate",
        type: "dateSingle",
        value: formatDate(),
        col: "12",
        sm: "3",
        lg: "3",
        menu: "",
        rules: [requiredInputRule],
    },
    {
        label: "입고시간",
        key: "inboundTime",
        column_name: "inboundTime",
        type: "hour",
        value: formatHour(),
        col: "12",
        sm: "3",
        lg: "3",
        rules: [requiredInputRule],
    },
    {
        label: "프로젝트 코드",
        key: "projectCode",
        column_name: "projectCode",
        col: "12",
        sm: "3",
        lg: "3",
        disabled: true,
        value: "",
    },
    {
        label: "입고사유 / 비고",
        key: "note",
        column_name: "note",
        type: "textarea",
        col: "12",
        sm: "3",
        lg: "3",
        value: "",
        clearable: true,
        rules: [requiredInputRule],
    },
    {
        label: "수입검사서",
        key: "receivingInspection",
        column_name: "receivingInspection",
        type: "file",
        col: "12",
        sm: "4",
        lg: "4",
        icon: "",
        appendIcon: "mdi-paperclip",
        smallChips: true,
        accept: ".pdf",
        clearable: true,
        value: null,
    },
    {
        label: "시험성적서",
        key: "inspectionReport",
        column_name: "inspectionReport",
        type: "file",
        col: "12",
        sm: "4",
        lg: "4",
        icon: "",
        appendIcon: "mdi-paperclip",
        smallChips: true,
        accept: ".pdf",
        clearable: true,
        value: null,
    },
    {
        label: "기타",
        key: "etcFiles",
        column_name: "etcFiles",
        type: "file",
        col: "12",
        sm: "4",
        lg: "4",
        icon: "",
        appendIcon: "mdi-paperclip",
        smallChips: true,
        multiple: true,
        clearable: true,
        value: null,
    },
];
export const purchaseInboundChecks = [
    {
        validator: (data) => !!(data.num && data.spot && data.unitPrice),
        errorMessage: "입고수량, 입고장소, 입고단가 필수 입력",
    },
    {
        validator: (data) => {
            const numStr = String(data.num).replace(/[, \s]/g, "");
            const num = numStr === "" ? 0 : Number(numStr);
            return !isNaN(num) && num > 0;
        },
        errorMessage: "입고수량은 0보다 커야합니다.",
    },
    {
        validator: (data) => {
            if (data.id)
                return true;
            return !!(data.type && data.classification && data.name);
        },
        errorMessage: "미연결 제품의 종류, 분류, 제품명은 필수 입력입니다.",
    },
];
